export const ROUTES = {
  HOME: "/",
  ACCOUNT: "/mi-cuenta",
  LOGIN: "/login",
  PRODUCT: "/product",
};
